import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'blog_gated_content-brandblogcontentformsubmission-action_unknown';
/**
 * Emit event to facebook when the BrandBlogContentFormSubmission event is fired.
 */
export function trackBlogGatedContentBrandblogcontentformsubmission(pixelCustomDataParams) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        facebookPixelEvent: 'BrandBlogContentFormSubmission',
        pixelCustomDataParams: pixelCustomDataParams,
    });
}
